import { useQuery } from "@tanstack/react-query";
import { getUserBlockStatus } from "../apis/chatApi";

export function useBlockStatus(otherUserId) {
  const { data } = useQuery({
    queryKey: ["blockStatus", otherUserId],
    queryFn: () => getUserBlockStatus(otherUserId),
    staleTime: 0,
    enabled: !!otherUserId,
  });
  return {
    blockedByMe: data?.blockedByMe ?? false,
    blockedByOther: data?.blockedByOther ?? false,
  };
}
